export default __webpack_public_path__ + "static/FReg-Goal4-e7091632f30f41c162c6c0f1c70c8f74.jpg";